<template>
    <a
        :href="link.url"
        target="_blank"
        rel="nofollow noopener"
        :class="[linkStyle, linkType, cleanType]"
        :data-text="linkType === 'text' ? cleanLabel : null"
    >
        <span v-if="linkType === 'text'">{{ cleanLabel }}</span>
        <i v-else :class="['fa', `fa-${cleanType}`]"></i>
    </a>
</template>

<script>
export default {
    name: "PortfolioNavigationSocialLinkItem",
    props: {
        link: {
            type: Object,
            default: null,
        },
        linkType: {
            type: String,
            default: "text",
        },
        linkStyle: {
            type: String,
            default: "simple",
        },
        upperCase: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        cleanType() {
            const raw = (this.link?.type || "").toString().toLowerCase();
            return raw === "x-twitter" ? "x" : raw;
        },
        cleanLabel() {
            const label = (this.link?.type || "").toString();
            return this.upperCase ? label.toUpperCase() : label;
        }
    }
};
</script>
